module.exports = __webpack_public_path__ + "img/SKMJ_train1.d8dbe7f8.png";